import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCountriesList } from '../modules/selectors/countries';
import { fetchCountriesAction } from '../modules/actions/countries';
import { ICountry } from '../modules/types';

/**
 * Returns the countries list, fetching it once if it hasn't been loaded yet.
 */
export function useCountriesList(): ICountry[] {
  const dispatch = useDispatch();
  const countriesList = useSelector(getCountriesList);

  useEffect(() => {
    if (!countriesList.length) {
      dispatch(fetchCountriesAction());
    }
  }, [dispatch, countriesList]);

  return countriesList;
}
